<template>
<div style="position: relative; z-index: 0">
<div :class="'block-text editor '+pClass" ref="editor" style="" v-html="actualValue"></div>
</div>
</template>
<script>

import tinymce from 'tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/skins/ui/oxide/skin.css';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/autoresize';
// import 'tinymce/plugins/paste';
import 'tinymce/models/dom/model';
import contentUiCss from '!!raw-loader!tinymce/skins/ui/oxide/content.css';
import contentCss from '!!raw-loader!tinymce/skins/content/default/content.css';

import { contentCss2 } from '../Form/FormWysiwyg.vue';
var contentCss3=`html, body { margin: 0 };`;

export default {
  props: ["modelValue", "isNew", "pClass"],
  data: ()=>({
    actualValue: null,
  }),
  mounted() {
    this.actualValue=this.modelValue;
    var config={
      target: this.$refs.editor,
      plugins: [ 'lists', 'link'/*, 'paste'*/, 'table', 'autoresize' ],
      table_toolbar: "",
      link_title: false,
//       toolbar: false,
      menubar: false,
      contextmenu: false,
      // inline: true,
      // start inline to classic change
      content_style: `${contentUiCss}\n${contentCss}\n${contentCss2}\n${contentCss3}`,
      link_title: false,
      menubar: false,
      skin: false,
      contextmenu: false,
      statusbar: false,
      height: 400,
      // end inline to classic change

      valid_styles: {
        "*": "color"
      },
      toolbar: "bold italic underline strikethrough forecolor | alignleft aligncenter alignright alignjustify | link unlink",
      formats: {
        serif: {block: "p", classes: "serif", exact: true},
      },
      style_formats: [
        {title: "Serif", format: "serif"},
      ],
      init_instance_callback: (editor)=>{
        this.initEditor(editor);
      },
      setup: (editor)=>{
        this.setupEditor(editor);
        
/*        editor.ui.registry.addToggleButton('serifText', {
          icon: 'change-case',
          tooltip: "Toggle serif font",
          onAction: function (_) {
            editor.execCommand('mceToggleFormat', false, 'serif');
          },
          onSetup: function (api) {
            editor.formatter.formatChanged('serif', function (state) {
              api.setActive(state);
            });
          }
        });  */
      },
    };
    if (this.pClass=='bquote')
      config.forced_root_block='blockquote';
    if (this.pClass=='ul' || this.pClass=='ol') {
      config.toolbar='bold italic underline strikethrough forecolor | outdent indent | link unlink';
    }
    if (this.pClass=='table') {
      config.toolbar='bold italic underline strikethrough forecolor | alignleft alignright | tablemergecells tablesplitcells tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol';
      config.table_toolbar="";
    }
    tinymce.init(config);
  },
  methods: {
    initEditor(editor) {
      this.editor=editor;
      editor.on('change', (e)=>{
        var content=editor.getContent();
        this.$emit("update:modelValue", content);
      });
      if (this.isNew) {
        setTimeout(()=>{
          editor.focus();
          this.$emit("new-init-done");
        }, 16);
      }
    },
    setupEditor(editor) {
      editor.on('keydown', (e)=>{
      });
      editor.on('paste', (e)=>{
        setTimeout(()=>{
          var content=editor.getContent();
          this.$emit("update:modelValue", content);
        }, 10);
      });
    }
  }
}
</script>
